module.exports = __webpack_public_path__ + "media/images/new_home/map-icon-artist-2dde224ef7d9f24c602698fa1f297036.png";